module.exports = __webpack_public_path__ + "static/media/redo-disabled-icon.dde7f989.svg";